// store/modules/auth/types.js
const types = {
  LOGIN_REQUEST: "@auth/LOGIN_REQUEST",
  LOGIN_SUCCESS: "@auth/LOGIN_SUCCESS",
  LOGIN_FAILURE: "@auth/LOGIN_FAILURE",

  REGISTER_REQUEST: "@auth/REGISTER_REQUEST",
  REGISTER_SUCCESS: "@auth/REGISTER_SUCCESS",
  REGISTER_FAILURE: "@auth/REGISTER_FAILURE",

  LOGOUT: "@auth/LOGOUT",
  LOGOUT_SUCCESS: "@auth/LOGOUT_SUCCESS",
  GOOGLE_LOGIN_REQUEST: '@auth/GOOGLE_LOGIN_REQUEST',

  VERIFY_TOKEN_REQUEST: "@auth/VERIFY_TOKEN_REQUEST",
  VERIFY_TOKEN_SUCCESS: "@auth/VERIFY_TOKEN_SUCCESS",
  VERIFY_TOKEN_FAILURE: "@auth/VERIFY_TOKEN_FAILURE",
};

export default types;
